import type { ReactElement } from 'react';
import {
  Button as LegacyButton,
  type ButtonProps,
} from '@tw/tw-component-library';
import { Button as WtButton } from '@tw/tw-component-library/common-wt';
import { useAppTheme } from '@/hooks/useAppTheme';
import { mapButtonProps } from './mapButtonVariant';

// ============= Component =============

/**
 * Brand-aware Button. Renders the Litium Button by default and swaps to the
 * Winston Taylor Button (with mapped variants) when the brand axis is set to
 * `winstonTaylor`. The public prop contract matches the Litium Button so
 * existing call sites can switch their import path without other changes.
 */
export const Button = (props: ButtonProps): ReactElement => {
  const { isWinstonTaylor } = useAppTheme();

  if (isWinstonTaylor) {
    return <WtButton {...mapButtonProps(props)} />;
  }

  return <LegacyButton {...props} />;
};
